import type { PersonFormSection } from '../types/vida/cadastralMaintenance/personFormTypes';

export const PERSON_FORM_SECTION_ORDER: PersonFormSection[] = [
  'personData',
  'personAddress',
  'insuranceInfo',
];

export const getNextPersonFormSection = (
  current: PersonFormSection,
): PersonFormSection | null => {
  const currentIndex = PERSON_FORM_SECTION_ORDER.indexOf(current);
  if (currentIndex < 0 || currentIndex >= PERSON_FORM_SECTION_ORDER.length - 1) {
    return null;
  }
  return PERSON_FORM_SECTION_ORDER[currentIndex + 1];
};

export const isLastPersonFormSection = (section: PersonFormSection): boolean =>
  section === 'insuranceInfo';
